<script setup lang="ts">
import {Dialog} from "@/core/components/ui/dialog";
import {computed} from "vue";
import ContestForm from "@/contest/components/ContestForm.vue";


const props = defineProps<
    { edit: true; contestId: number; open?: boolean }
    | { edit?: false; contestId?: number; open?: boolean }
>();

const emits = defineEmits(['on-refresh', 'update:open']);

const modalOpen = computed({
    get: () => props.open ?? false,
    set: (value) => emits('update:open', value)
});
</script>

<template>
  <Dialog v-model:open="modalOpen">
    <ContestForm
      v-if="contestId"
      :edit="true"
      :contest-id="contestId"
      :open-state="modalOpen"
      @on-refresh="emits('on-refresh')"
      @update:open="emits('update:open', $event)"
    />
  </Dialog>
</template>

<style scoped>

</style>